
import { prop, Vue } from "vue-class-component";

class Props {
  fill = prop({ default: false, type: Boolean });
}
export default class Bell extends Vue.with(Props) {}
